"use strict";

var isEnvelope = require('./isEnvelope');

var isPaperComponent = require('./isPaperComponent');

var isLetterpressComponent = require('./isLetterpressComponent');

var isShipment = require('./isShipment');

var hasEmbellishments = require('./hasEmbellishments');

var isWrapper = require('./isWrapper');

var isRibbon = require('./isRibbon');

var calculatePrintByDate = require('./calculatePrintByDate');

var computeCopies = require('./computeCopies');

var computeExactQuantity = require('./computeExactQuantity');

var computeRoundedQuantity = require('./computeRoundedQuantity');

var removeHTML = require('./removeHTML');

var roundUp = require('./roundUp');

module.exports = {
  isEnvelope: isEnvelope,
  isPaperComponent: isPaperComponent,
  isLetterpressComponent: isLetterpressComponent,
  isShipment: isShipment,
  hasEmbellishments: hasEmbellishments,
  isWrapper: isWrapper,
  isRibbon: isRibbon,
  calculatePrintByDate: calculatePrintByDate,
  computeCopies: computeCopies,
  computeExactQuantity: computeExactQuantity,
  computeRoundedQuantity: computeRoundedQuantity,
  removeHTML: removeHTML,
  roundUp: roundUp
};